import React from "react";
import { Skeleton } from "@mui/material";
import "./FixtureStyles.scss";

interface GroupTableSkeletonProps {
  isDesktop?: boolean;
  /** Teams per group; placeholder rows to render while data loads. */
  rows?: number;
}

// Mirrors GroupTable's layout so the placeholder lines up with the real
// standings and there is no layout shift once the group data arrives.
const GroupTableSkeleton: React.FC<GroupTableSkeletonProps> = ({
  isDesktop,
  rows = 4,
}) => {
  const flagSize = isDesktop ? 30 : 24;

  return (
    <div className={`groupTable${isDesktop ? " groupTable--desktop" : ""}`}>
      <div className="groupTable__header">
        <span className="groupTable__pos">#</span>
        <span className="groupTable__teamHead">Country</span>
        <span className="groupTable__stat groupTable__stat--pts">Pts</span>
        <span className="groupTable__stat">W</span>
        <span className="groupTable__stat">D</span>
        <span className="groupTable__stat">L</span>
      </div>

      {Array.from({ length: rows }).map((_, index) => (
        <div className="groupTable__row" key={`group-skeleton-${index}`}>
          <span className="groupTable__pos">{index + 1}</span>
          <span className="groupTable__team">
            <span className="groupTable__flag">
              <Skeleton variant="circular" width={flagSize} height={flagSize} />
            </span>
            <span className="groupTable__name">
              <Skeleton variant="text" width={isDesktop ? 120 : 70} />
            </span>
          </span>
          <span className="groupTable__stat groupTable__stat--pts">
            <Skeleton variant="text" width={16} />
          </span>
          <span className="groupTable__stat">
            <Skeleton variant="text" width={16} />
          </span>
          <span className="groupTable__stat">
            <Skeleton variant="text" width={16} />
          </span>
          <span className="groupTable__stat">
            <Skeleton variant="text" width={16} />
          </span>
        </div>
      ))}
    </div>
  );
};

export default GroupTableSkeleton;
